export const PHOTO_GUIDELINES_COPY = {
  headerTitle: 'Orientação de como enviar as suas fotos posturais',
  intro: {
    beforeBold: 'Este guia foi criado para auxiliar você a fazer as ',
    bold: 'fotos posturais',
    afterBold:
      ' da melhor forma possível e para que assim possamos acompanhar o seu processo evolutivo.\n\nSe surgir qualquer dúvida durante o passo-a-passo, fale com nosso suporte pelo chat do app. Estamos aqui para você!',
  },
  orientationsTitle: 'Orientações',
  guidelines: [
    'Precisamos que as fotos sejam bem feitas, pois são de extrema importância na avaliação correta do padrão postural;',
    'Se possível, opte por uma iluminação natural para evitar sombreamentos em seu corpo;',
    'A câmera deve ficar posicionada em um ângulo em que a foto seja retirada na altura do seu umbigo;',
    'A foto deve enquadrar todo o seu corpo, sem que nenhuma parte seja cortada. É extremamente importante para nós avaliarmos você como um todo, inclusive a forma como você pisa no chão;',
    'As fotos deverão ser repetidas utilizando a mesma roupa para que possamos acompanhar a sua evolução. Isso nos ajuda a fazer com que você também perceba as mudanças. Evoluções visíveis são mais valorizadas e te fazem enxergar o trabalho duro dando resultado;',
    'Indicamos que você utilize biquíni como vestimenta ao realizar as fotos;',
    'Se você se sentir mais confortável, as fotos podem ser tiradas de forma a esconder o rosto, fica a seu critério;',
    'Essas fotos são sigilosas, portanto, não as utilizaremos ou compartilharemos sob nenhuma hipótese sem a sua autorização;',
    'No caso de cabelos longos, faça um coque para que o cabelo não cubra as costas, pois atrapalha na visualização.',
  ],
  tipsTitle: 'Dicas',
  avoidTitle: 'O que evitar:',
  avoidItems: [
    'Cortar as pernas e os pés da foto que será enviada;',
    'Inverter a posição das mãos ao fazer a foto frontal;',
    'Afastar os braços do tronco ou levantá-los;',
    'Um fundo muito poluído. Dê preferência a um fundo liso e livre do acúmulo de informações.',
  ],
  howToTitle: 'Como fazer suas fotos:',
  howToSubtitle:
    'Tenha em mente que as fotos precisam sair na mesma altura do umbigo e a partir disso:',
  howToItems: [
    'Coloque o celular na câmera frontal;',
    'Ative o temporizador em 10 segundos, clique no botão de tirar a foto;',
    'Vá para a pose;',
    'Aguarde os 10 segundos.',
  ],
  positions: {
    front: {
      title: 'Frente',
      instructions: {
        head: 'Cabeça alinhada com os olhos na linha do horizonte',
        torso: 'Tronco ereto',
        arms: 'Braços pendendo ao lado do corpo',
        feet: 'Pés paralelos a linha do quadril',
      },
    },
    back: {
      title: 'Costas',
      instructions: {
        head: 'Cabeça alinhada com os olhos na linha do horizonte',
        torso: 'Tronco ereto',
        arms: 'Braços pendendo ao lado do corpo',
        feet: 'Pés paralelos a linha do quadril',
      },
    },
    right_side: {
      title: 'Lado direito',
      instructions: {
        head: 'Cabeça alinhada com os olhos na linha do horizonte',
        torso: 'Flexionar os ombros em 90° mantendo os cotovelos dobrados',
        arms: 'Tronco ereto',
        feet: 'Pés paralelos a linha do quadril',
      },
    },
    left_side: {
      title: 'Lado esquerdo',
      instructions: {
        head: 'Cabeça alinhada com os olhos na linha do horizonte',
        torso: 'Flexionar os ombros em 90° mantendo os cotovelos dobrados',
        arms: 'Tronco ereto',
        feet: 'Pés paralelos a linha do quadril',
      },
    },
  },
} as const;
